import axiosInstance from './config/api';
import { UserRoleType } from 'types/userRoles';

export interface PostLoginResponse {
    tenantId: string;
    token: string;
    userRole: UserRoleType[];
    tenantStatus?: string;
}

/** Pure Platform login call — no navigation side effects. */
export const postLogin = async (idToken: string): Promise<PostLoginResponse> => {
    return axiosInstance
        .post('/auth/login', {}, { headers: { Authorization: `Bearer ${idToken}` } })
        .then((res) => res.data as PostLoginResponse);
};
